import { cva } from '@/styled-system/css';

export const comboboxAdornmentRecipe = cva({
  base: {
    'display': 'inline-flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'flexShrink': 0,
    'width': 'Combobox.Adornment.width',
    'height': 'Combobox.Adornment.height',

    '& [data-c11n-component="Icon"]': {
      color: 'Combobox.Adornment.icon.trailing.default',
    },
  },
  variants: {
    size: {
      sm: {
        marginInlineStart: 'Combobox.Trigger.sm.gap.trailing',
      },
      md: {
        marginInlineStart: 'Combobox.Trigger.md.gap.trailing',
      },
      lg: {
        marginInlineStart: 'Combobox.Trigger.lg.gap.trailing',
      },
    },
  },
});
